const generateImgAlt = text => {
  return /[^/]*$/.exec(text)[0].replace(/_/g, ' ').replace(/-/g, ' ');
};

export default generateImgAlt
